module.exports = __webpack_public_path__ + "f4ebe485bc50abaf580cf6ae9895dde5.png";